import { Vehicle } from '@sharedTypes/Vehicle';

interface ReservationHeaderProps {
  photo: string;
  vehicle: Vehicle;
}

const ReservationHeader = ({
  photo,
  vehicle,
}: ReservationHeaderProps): JSX.Element => {
  return (
    <div className="db-vehicle__wrapper ch-mb--3 sm:ch-mb--5">
      {photo && (
        <img alt="" className="ch-img--responsive ch-rounded--md" src={photo} />
      )}
      <div className="db-vehicle__content">
        <span className="db-vehicle__title ch-fs--3 sm:ch-fs--4 ch-mv--1">
          {vehicle.make} {vehicle.model}
          <span className="db-vehicle__variant ch-text--ellipsis ch-color--grey-6 ch-mt--1">
            {vehicle.variant}
          </span>
        </span>
        <span className="ch-color--ac-pricing ch-fs--2 sm:ch-fs--3 ch-fw--500">
          £99 refundable deposit
        </span>
      </div>
    </div>
  );
};

export default ReservationHeader;
